import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useTheme } from '../../lib/theme';

const PLAN_LABEL = { starter: 'Starter', business: 'Business', accountant: 'Accountant' };
const STATUS_MAP = {
  paid: { label: 'Paid', fg: '#166534', bg: '#DCFCE7' },
  open: { label: 'Open', fg: '#92400E', bg: '#FEF3C7' },
  draft: { label: 'Draft', fg: '#525966', bg: '#F3F4F6' },
  uncollectible: { label: 'Failed', fg: '#991B1B', bg: '#FEE2E2' },
  void: { label: 'Refunded', fg: '#525966', bg: '#F3F4F6' },
};

export default function PaymentHistoryTable({ invoices }) {
  const { colors } = useTheme();
  if (!invoices || invoices.length === 0) {
    return (
      <div
        data-testid="payment-history-empty"
        style={{ padding: 24, borderRadius: 14, border: `1px dashed ${colors.border}`, color: colors.textMuted, textAlign: 'center', fontSize: 14 }}
      >
        No payments yet — enjoy your free trial.
      </div>
    );
  }
  return (
    <div data-testid="payment-history-table" style={{ borderRadius: 14, border: `1px solid ${colors.border}`, overflow: 'hidden', background: colors.surface }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead style={{ background: colors.surfaceSoft || colors.accentSoft }}>
          <tr>
            <th style={th(colors)}>Date</th>
            <th style={th(colors)}>Amount</th>
            <th style={th(colors)}>Plan</th>
            <th style={th(colors)}>Status</th>
            <th style={{ ...th(colors), textAlign: 'right' }}>Receipt</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((inv) => {
            const s = STATUS_MAP[inv.status] || { label: inv.status || '—', fg: colors.textMuted, bg: colors.border };
            const date = inv.created_at ? new Date(inv.created_at) : null;
            return (
              <tr key={inv.id} style={{ borderTop: `1px solid ${colors.border}` }} data-testid={`invoice-row-${inv.id}`}>
                <td style={td(colors)}>{date ? date.toLocaleDateString() : '—'}</td>
                <td style={td(colors)}>${inv.amount_total.toFixed(2)} {inv.currency}</td>
                <td style={td(colors)}>{PLAN_LABEL[inv.plan_code] || inv.plan_code || '—'}</td>
                <td style={td(colors)}>
                  <span style={{ padding: '2px 10px', borderRadius: 999, background: s.bg, color: s.fg, fontSize: 11, fontWeight: 700, letterSpacing: '0.03em', textTransform: 'uppercase' }}>
                    {s.label}
                  </span>
                </td>
                <td style={{ ...td(colors), textAlign: 'right' }}>
                  {inv.hosted_invoice_url ? (
                    <a href={inv.hosted_invoice_url} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: colors.accent, textDecoration: 'none', fontWeight: 600 }}>
                      View <ExternalLink size={12} />
                    </a>
                  ) : (
                    <span style={{ color: colors.textMuted }}>—</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

const th = (c) => ({ padding: '12px 16px', textAlign: 'left', color: c.textMuted, fontWeight: 700, fontSize: 11, letterSpacing: '0.06em', textTransform: 'uppercase' });
const td = (c) => ({ padding: '12px 16px', color: c.text });
